let instance = null;
import GSAP from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import SmoothScroll from '../utils/SmoothScroll'
import Cursor from "../components/Cursor";
import Form from "../components/Form";
import Accordion from "../components/Accordion";
import Buttons from "../components/Buttons";
import VideoObserver from "../components/VideoObserver";
import HtmlVideoPlayer from "../components/HtmlVideoPlayer";
import Nav from "../components/Nav";
import PageObserver from "../components/PageObserver";
import BlockObserver from "../components/BlockObserver";
import Dropdown from '../components/Dropdown';
import Modal from "../components/Modals";
import LoadPost from "../components/LoadPosts";
import "../components/CookiesConsent";
import NavScrollLoop from "../components/NavScrollLoop";
import Ticker from "../components/Ticker";
import LogoTicker from "../components/LogoTicker";
import Slideshow from "../components/Slideshow";
import Carousel from "../components/Carousel";
import Testimonial from "../components/Testimonial";
import PageProgress from "../components/PageProgress";
import Timeline from "../components/Timeline";
import ImageParallax from "../components/ImageParallax";
import CurrentListening from "../components/CurrentListening";

export default class App {
	constructor() {


		// ============================================================================================
		// SETUP APP
		// ============================================================================================

		// Create singleton
		if (instance) {
			return instance;
		}
		instance = this;


		// Create global access
		window.app = this;


		// Get context
		this.getContext();
		window.addEventListener('resize', () => {
			this.getContext();
		});


		// ============================================================================================
		// GLOBAL FUNCTIONS
		// ============================================================================================

		this.pageObserver 	= new PageObserver()
		this.blockObserver	= new BlockObserver( document.querySelectorAll('[data-watch="true"]') )
		this.nav			= document.querySelector('.nav')
		this.navigation		= new Nav()
		this.modal 			= new Modal();
		// this.loadPosts 		= new LoadPost();
		this.timeline		= new Timeline();
		this.imageParallax	= new ImageParallax();
		this.cursor			= new Cursor();

		// SETTING UP SMOOTH SCROLLING
		this.smoothScroll = new SmoothScroll()

		if(document.querySelector('.nav__menu .nav__menuwrapper')) {
			this.navScrollLoop	= new NavScrollLoop(document.querySelector('.nav__menu .nav__menuwrapper'))
		}

		// ============================================================================================
		// FORMS with custom UI
		// ============================================================================================
		
		const contactForm = document.querySelector('#gform_1')
		if(contactForm) {
			new Form(contactForm)
		}

		// ============================================================================================
		// COMPONENTS
		// ============================================================================================


		this.buttons = document.querySelectorAll('.btn--arrow');
		this.buttons && this.buttons.forEach((button)=>
		{
			new Buttons(button);
		})


		this.accordions = [... document.querySelectorAll('[data-component="accordion"]')];
		this.accordions && this.accordions.forEach((accordion,inx)=>{
			this.accordions[inx] = new Accordion(accordion);
			this.accordions[inx].init()
		})

		this.loadPosts 		= new LoadPost();



		this.dropdowns = document.querySelectorAll('[data-component="dropdown"]');
		this.dropdowns && this.dropdowns.forEach((dropdown)=>{
			new Dropdown(dropdown).init();
		})



		this.htmlVideos = document.querySelectorAll('.video--html');
		this.htmlVideos && this.htmlVideos.forEach((video)=>
		{

			let options =
			{
				autoplay: false,
				loop: true,
				muted: true,
				controls: true,
				cover: false,
			}

			if( video.classList.contains('video--autoplay') ){
				options.autoplay = true;
				options.controls = false;
			}

			if( video.classList.contains('video--cover') ){
				options.cover = true;
			}
			
			new HtmlVideoPlayer(video, options);

		})


		this.ticker = document.querySelectorAll('[data-component="ticker"]');
		this.ticker && this.ticker.forEach((ticker)=>{
			new Ticker(ticker);
		})



		this.logoticker = document.querySelectorAll('[data-component="logoticker"]');
		this.logoticker && this.logoticker.forEach((logoticker)=>{
			new LogoTicker(logoticker);
		})


		this.carousel = document.querySelectorAll('[data-component="carousel"]');
		this.carousel && this.carousel.forEach((carousel)=>{
			new Carousel(carousel);
		})


		this.slideshow = document.querySelectorAll('[data-component="slideshow"]');
		this.slideshow && this.slideshow.forEach((slideshow)=>{
			new Slideshow(slideshow);
		})


		this.testimonial = document.querySelectorAll('[data-component="testimonials"]');
		this.testimonial && this.testimonial.forEach((testimonial)=>{
			new Testimonial(testimonial);
		})


		this.pageProgress = document.querySelectorAll('[data-component="pageprogress"]');
		this.pageProgress && this.pageProgress.forEach((pageProgress)=>{
			new PageProgress(pageProgress);
		})


		this.currentListening = document.querySelector('[data-component="spotify"]');
		if(this.currentListening){ 
			new CurrentListening(this.currentListening);
		}


		this.formTextArea = document.querySelectorAll('textarea.textarea');
		this.formTextArea && this.formTextArea.forEach((textArea)=> {
			textArea.style.height = "40px";
			textArea.addEventListener("input", (event) => {
				if(textArea.value === '') {
					textArea.style.height = "40px";
				} else {
					textArea.style.height = (textArea.scrollHeight) + "px";
				}
			});
		})

		this.horizontalScroller = document.querySelectorAll('.horizontal-scroll');
		this.horizontalScroller && this.horizontalScroller.forEach((horizontalScroll)=> {
			const slider = horizontalScroll
			let isDown = false;
			let startX;
			let scrollLeft;

			slider.addEventListener('mousedown', (e) => {
				e.preventDefault();
				isDown = true;
				slider.classList.add('active');
				startX = e.pageX - slider.offsetLeft;
				scrollLeft = slider.scrollLeft;
			});
			slider.addEventListener('mouseleave', (e) => {
				e.preventDefault();
				isDown = false;
				slider.classList.remove('active');
			});
			slider.addEventListener('mouseup', (e) => {
				e.preventDefault();
				isDown = false;
				slider.classList.remove('active');
			});
			slider.addEventListener('mousemove', (e) => {
				if(!isDown) return;
				e.preventDefault();
				const x = e.pageX - slider.offsetLeft;
				const walk = (x - startX);
				slider.scrollLeft = scrollLeft - walk;
			});
		})


	}
 
	getContext() {
		// Tells us if App is Mobile

		if (window.matchMedia("(max-width: 1024px)").matches) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}

		if (window.matchMedia("(hover: none)").matches) {
			this.isTouch = true;
		} else {
			this.isTouch = false;
		}

		if (window.location.host.includes("localhost")) {
			this.URL =
				"http://" +
				window.location.host +
				`/${REPO}/wp-content/themes/${THEME}`;
		} else {
			this.URL =
				"https://" + window.location.host + `/wp-content/themes/${THEME}`;
		}

	}
}